'use client';

import { useTranslations } from 'next-intl';
import { LoginButton } from 'components/pcc-components';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { normalizeCommerceLink, getSeoUrl } from 'utils/links';
import { B2C_LOGIN_URL } from 'constants/links';
import { useEffect, useState } from 'react';

export const SignInButton = ({
  className,
  fullWidth = true,
  variant,
  pageRedirectUrl
}: {
  className?: string;
  variant?:
    | 'primary'
    | 'contrast'
    | 'danger'
    | 'ghost'
    | 'ghost-danger'
    | 'inline';
  fullWidth?: boolean;
  pageRedirectUrl?: string;
}) => {
  const t = useTranslations();
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const pageRedirectUrlByParams = searchParams.get('pageRedirectUrl');
  const [currentUrl, setCurrentUrl] = useState('');
  const isHomePage = esiteUrl === pathname;
  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl: pageRedirectUrl || pageRedirectUrlByParams || currentUrl || pathname,
      loginFromHomePage: isHomePage
    })
  );


  useEffect(() => {
    // Check if the code is running on the client side
      // Access the current page URL using window.location
      if(window.location.search) {
      setCurrentUrl(`${window.location.pathname}${window.location.search}`);        
      }
  }, []);



  return (
    <LoginButton
      variant={variant}
      className={className}
      href={loginUrl}
      fullWidth={fullWidth}
    >
      {t('SIGN_IN')}
    </LoginButton>
  );
};
